module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "TrailbluGenAI.0b2ac43b.gif";